export const useValidation = (
  rule: ValidationRule,
  ruleField: ValidationRuleField
) => {

  const { ls } = useI18n()
  const dataStore = useDataStore()
  const { $getValidationRuleEnum } = useNuxtApp()

  const label = computed((): string => {
    return ls(rule.fields[ruleField.field].label)
  })

  const description = computed((): string => {
    return ls(rule.fields[ruleField.field].description)
  })

  const isImageSelection = computed((): boolean => {
    return ruleField.objRuleName === 'jps-image_selection'
  })

  const isArray = computed((): boolean => {
    return ruleField.type === 'array'
  })

  const isLangString = computed((): boolean => {
    return (
      ruleField.objRuleName === 'jps-lang_string' ||
      ruleField.objRuleName === 'jps-lang_string_yomi'
    )
  })

  const hasYomi = computed((): boolean => {
    return ruleField.objRuleName === 'jps-lang_string_yomi'
  })

  const isTag = computed((): boolean => {
    return ruleField.objRuleName === 'jps-tag_field'
  })

  const isObject = computed((): boolean => {
    return !isImageSelection.value && ruleField.type === 'object'
  })

  const isText = computed((): boolean => {
    return (
      !isCode.value &&
      !isEnum.value &&
      (ruleField.type === 'string' ||
        ruleField.arraySubType === 'string')
    )
  })

  const isMultiline = computed((): boolean => {
    return ruleField.allowMultiline
  })

  const isCheckbox = computed((): boolean => {
    return (
      ruleField.type === 'bool' || ruleField.arraySubType === 'bool'
    )
  })

  const isNumber = computed((): boolean => {
    return (
      ruleField.type === 'number' ||
      ruleField.arraySubType === 'number'
    )
  })

  const isCode = computed((): boolean => {
    return ruleField.codeKey != null
  })

  const code = computed((): Code | null => {
    if (ruleField.codeKey) {
      return dataStore.code(ruleField.codeKey)
    }
    return null
  })

  const codeKeys = computed((): string[] => {
    if (code.value) {
      let codeKeys = []
      if (!ruleField.mandatory) codeKeys.push(null)
      code.value.values.map((v) => codeKeys.push(v.code))
      return codeKeys
    } else {
      return []
    }
  })

  const isEnum = computed((): boolean => {
    return ruleField.enumKey != null
  })

  const enumKey = computed((): string => {
    if (isEnum.value) return ruleField.enumKey
  })

  const enumuration = computed((): string[] => {
    if (isEnum.value) {
      let r = []
      if (!ruleField.mandatory && !isArray.value) r.push(null)
      r.push(...enumKeys.value)
      return r
    }
  })

  const enumValue = computed((): EnumDef => {
    if (isEnum.value) {
      const validationRuleEnum = $getValidationRuleEnum()
      if (validationRuleEnum[enumKey.value]) {
        return validationRuleEnum[enumKey.value]
      } else {
        return rule.enums[enumKey.value]
      }
    }
  })

  const enumKeys = computed((): string[] => {
    if (isEnum.value) return Object.keys(enumValue.value.c)
  })

  const isDate = computed((): boolean => {
    return ruleField.isDate
  })

  return {
    label,
    description,
    isImageSelection,
    isArray,
    isLangString,
    hasYomi,
    isTag,
    isObject,
    isText,
    isMultiline,
    isCheckbox,
    isNumber,
    isCode,
    code,
    codeKeys,
    isEnum,
    enumKey,
    enumuration,
    enumValue,
    enumKeys,
    isDate,
  }
}
